import { useState } from 'react'
import {
  Typography,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  TablePagination,
} from '@material-ui/core'
import { CollegeDocumentType, DOCUMENT_LABELS } from 'common/document.labels.type'

import ViewDocumentTrigger from 'material/ViewDocumentTrigger'

export type BatchedDocument = {
  type: CollegeDocumentType
  batchDate: string
  id: string
  batchId: string
}

const rowsPerPage = 10
function BatchedDocumentsTable({
  data,
  isPermitted,
  studentFirstName,
  studentLastName,
  collegeScid,
}: {
  data: BatchedDocument[]
  isPermitted: boolean
  studentFirstName: string
  studentLastName: string
  collegeScid: number
}) {
  const [page, setPage] = useState(0)
  if (data.length === 0) {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
      >
        No docs have been sent for this application
      </Typography>
    )
  }
  return (
    <>
      <TableContainer
        component={Box}
        width="100%"
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Document Type</TableCell>
              <TableCell>Batch Date</TableCell>
              {isPermitted && <TableCell>Action</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(({ id, batchId, type, batchDate }) => (
                <TableRow key={id}>
                  <TableCell>{DOCUMENT_LABELS[type] || type}</TableCell>
                  <TableCell>{batchDate}</TableCell>
                  {isPermitted && (
                    <TableCell>
                      <ViewDocumentTrigger
                        firstName={studentFirstName}
                        lastName={studentLastName}
                        label={DOCUMENT_LABELS[type]}
                        scid={collegeScid}
                        batchId={batchId}
                        recordId={id}
                      />
                    </TableCell>
                  )}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[rowsPerPage]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, newPage) => {
          setPage(newPage)
        }}
      />
    </>
  )
}

export default BatchedDocumentsTable
